import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { LoginService } from '../../common/services/Login.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { Router } from '@angular/router';
import { Input } from '@angular/core';
import scrollIntoView from 'scroll-into-view-if-needed'


@Component({
  selector: 'app-pendingcontentsystem-faq',
  templateUrl: './pendingcontentsystem-faq.component.html'
})
export class PendingcontentsystemFAQComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService, private route: Router) {
  }
  FAQ_Header;
  FAQ_GeneralHeader;
  FAQ_GeneralDescription;
  FAQ_UserInputHeader;
  FAQ_UserInputDescription;
  FAQ_SystemLimitationHeader;
  FAQ_SystemLimitationDescription;
  @Input() TargetDivId: string;
  @Input() IsRightPanel: boolean = false;

  ngOnInit(): void {
    
    this.commonDataService.showLoader.next(true);
    this.getPendingSystemContentFAQlabels();
  }
  getPendingSystemContentFAQlabels() {

    this.graphQlService.getPendingsystemContentFAQlabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.FAQ_Header = labels.filter(x => x.key == "FAQ_Header").map(y => y.value);
        this.FAQ_GeneralHeader = labels.filter(x => x.key == "FAQ_GeneralHeader").map(y => y.value);
        this.FAQ_GeneralDescription = labels.filter(x => x.key == "FAQ_GeneralDescription").map(y => y.value);
        this.FAQ_UserInputHeader = labels.filter(x => x.key == "FAQ_UserInputHeader").map(y => y.value);
        this.FAQ_UserInputDescription = labels.filter(x => x.key == "FAQ_UserInputDescription").map(y => y.value);

        this.FAQ_SystemLimitationHeader = labels.filter(x => x.key == "FAQ_SystemLimitationHeader").map(y => y.value);
        this.FAQ_SystemLimitationDescription = labels.filter(x => x.key == "FAQ_SystemLimitationDescription").map(y => y.value);


        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

  ngAfterViewInit() {

    setTimeout(() => {

      let el = document.getElementById(this.TargetDivId);

      if(el!=null){
        scrollIntoView(el, {
          scrollMode: 'always',
          block: 'start',
          inline: 'start',
          boundary: document.getElementsByTagName('app-main-content')[0]
        })
      }
    }, 350);


  }

}
